import { authRoles } from 'app/auth';
import { routesUrl } from 'app/fuse-configs/navigationConfig';
import { lazy } from 'react';

const SatisfactionPageConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.owner,
  routes: [
    {
      path: routesUrl.satisfaction,
      component: lazy(() => import('app/main/apps/satisfaction/pages/SatisfactionPage')),
    },
  ],
};

export default SatisfactionPageConfig;
